<template>
    <div class="form-row align-items-center mb-3">
        <div class="col-auto">
            Show
        </div>
        <div class="col-auto">
            <select class="form-control  form-control-sm"
                    v-model="pageSize">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
            </select>
        </div>
        <div class="col-auto">
            <div class="col-auto">
                rows
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'PageSize',
        props: ['value'],
        beforemount() {
            this.pageSize = this.value
        },
        mounted() {
            this.pageSize = this.value
        },
        data: () => {
            return {
                pageSize: null
            }
        },
        watch: {
            'value': function (newVal) {
                this.pageSize = this.value
            },
            'pageSize': function() { this.$emit('input', this.pageSize) }
        }
    }
</script>